import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";

import useVehicleList, { IVehicle } from "../../../hooks/useVehicleList";
import useCurrentVeichle from "../../../../../hooks/useVehicle";
import styles from "./index.module.scss";

interface IVehicleChoiceItem {
  label: string;
  vin: string;
  plateNumber?: string;
}

export default function VehicleCard(props: {
  onSwitchCar: (t: IVehicle) => void;
  selectedVehicle: IVehicle | null;
}) {
  const { vehicleList } = useVehicleList();
  const { handleCurrentVeichle } = useCurrentVeichle();
  const [showCarList, setShowCarList] = useState(false);
  const preBodyPositionState = useRef("");

  useEffect(() => {
    if (showCarList) {
      preBodyPositionState.current = document.body.style.position;
      document.body.style.position = "fixed";
      document.body.style.width = "100vw";
    } else {
      document.body.style.position = preBodyPositionState.current || "static";
      document.body.style.width = "auto";
    }
  }, [showCarList]);

  const onTapSwitchCar = () => {
    setShowCarList((preState) => !preState);
  };

  // 点击切换车型
  const onTapCarItemHandler = (item) => {
    // console.log('切换车型中 onTapCarItemHandlerrrrrrrrrrr', item);
    // console.log('切换车型中 curVehicleeeeeeeeeeeeeee isssss', baseInfo.selectedVehicle?.label);
    const { vin } = item;
    const { vin: curVin } = props.selectedVehicle || {};
    if (curVin === vin) {
      console.log("vin 相同~");
      setShowCarList(false);
      return;
    }
    // setCurSelectedCar(label);
    // setCurVehicle(item);
    handleCurrentVeichle(item);

    props.onSwitchCar(item);
    setShowCarList(false);
  };

  return (
    <div className={styles.vehicleWrapper}>
      <div className={styles.mainInfo}>
        <div className={styles.leftSide}>
          <div className={styles.plateNumInfo}>
            {props.selectedVehicle?.label && (
              <div className={styles.plateNum}>
                {props.selectedVehicle.label}
              </div>
            )}
            {vehicleList && vehicleList.length > 1 && (
              <div className={styles.switchCarField} onClick={onTapSwitchCar}>
                <i className={styles.switchIcon} />
                {showCarList && (
                  <div className={styles.carListField}>
                    <div className={styles.carList}>
                      {vehicleList.map((vehicleItem) => {
                        return (
                          <div
                            key={vehicleItem.vin}
                            className={classNames(styles.carListItem, {
                              // [styles.selected]: vehicleItem.label === baseInfo.selectedVehicle?.label,
                              [styles.selected]:
                                vehicleItem.vin === props.selectedVehicle?.vin
                            })}
                            onClick={(e) => {
                              e.stopPropagation();
                              onTapCarItemHandler(vehicleItem);
                            }}
                          >
                            {vehicleItem.label}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      {
        // 遮罩
        showCarList &&
          ReactDOM.createPortal(
            <div
              className={styles.carListMask}
              onClick={() => setShowCarList(false)}
            />,
            document.body
          )
      }
    </div>
  );
}
